var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1478_2096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.40909 13.26C1.37565 13.7382 1.7369 14.1158 2.23665 14.1507L8.2914 14.5741L4.53135 22.7377C3.98309 23.9374 5.23478 24.6901 6.1368 23.7489L16.7939 12.502C17.0082 12.2617 17.1313 12.0366 17.1501 11.7671C17.1835 11.2889 16.8332 10.912 16.3226 10.8763L10.2678 10.4529L14.0278 2.28932C14.587 1.09043 13.3244 0.33698 12.4224 1.27823L1.76524 12.525C1.55098 12.7654 1.42793 12.9905 1.40909 13.26Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1478_2096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 24,
    fill: "white",
    transform: "translate(2.33057 0.0839844) rotate(4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark);
export default __webpack_public_path__ + "static/media/spark.c55be4c3b6bb3962d5ad95d5c4da03ad.svg";
export { ForwardRef as ReactComponent };